import React from 'react';
import Small from 'components/common/Small';
import { string } from 'prop-types';

import './ShortDisclaimer.scss';

const ShortDisclaimer = ({ short }) => (
  <div className="tiShortDisclaimer">
    <Small>
      {short}
    </Small>
  </div>
);

ShortDisclaimer.propTypes = {
  short: string,
};

export default ShortDisclaimer;
